import css from 'styled-jsx/css';

const styles = css.global`.button-card {
  background: none;
  outline: none;
  border: none;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  border-radius: 4px;
  padding: 16px 8px;
  box-sizing: border-box;
  background-color: #fff;
  box-shadow: 0px 4px 8px 0px #22222240;

  width: 116px;
  height: 96px;

  gap: 4px;

  cursor: pointer;
}

.button-card.selected {
  background-color: #cc0000;
}

.button-card .btn-icon {
  pointer-events: none;
}

.button-card .btn-text {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'SantanderMicroText';
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0%;
  text-align: center;
  color: #444444;
  height: 40px;
  pointer-events: none;
}

.button-card.selected .btn-icon {
  filter: invert(100%) sepia(100%) grayscale(100%) brightness(200%);
}

.button-card.selected .btn-text {
  color: #fff;
}
`;

export default styles;